<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll" >


        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding: 10px ">

                <div class="row mb-32 gy-0 dash-top">

                    <!-- POSTS -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -75px;"></h2>

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none"> Collections
                                                </h3>
                                                <p class="hp-p1-body mm-none" style="text-align: center;">Manage lists and collections</p>

                                                <div class="mm-none">
                                                    <div class="divider mt-18 mb-16 "></div>
                                                </div>

                                                <div class="row g-24">
                                                    
                                                    <router-link :to="{name: 'user-lists'}" class="col-12 mt-32" style="cursor: pointer;" >
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    
                                                                    <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-primary-4 hp-bg-color-dark-primary rounded-circle" style="margin-right: 20px;">
                                                                        <i class="iconly-Light-People text-primary hp-text-color-dark-primary-2" style="font-size: 24px;"></i>
                                                                    </div>

                                                                    <div>
                                                                        <h5 class="mb-0">User lists</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Manage followers, following and fans list</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Manage followers, following and fans list</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                
                                                            </div>
                                                        </div>

                                                        <div class="divider mt-32  mb-0"></div>

                                                    </router-link>

                                                    <router-link :to="{name: 'bookmarks'}" class="col-12 " style="cursor: pointer;" >
                                                        <div class="row align-items-center justify-content-between">
                                                            <div class="col hp-flex-none w-auto">
                                                                <div class="d-flex align-items-center">
                                                                    
                                                                    <div class="avatar-item d-flex align-items-center justify-content-center avatar-lg bg-primary-4 hp-bg-color-dark-primary rounded-circle" style="margin-right: 20px;">
                                                    <i class="iconly-Light-Bookmark text-primary" style="font-size: 24px;"></i>
                                                </div>

                                                                    <div>
                                                                        <h5 class="mb-0">Bookmarks</h5>
                                                                        <p class="mb-0 hp-badge-text fw-normal mm-none">
                                                                            Manage your bookmarked posts</p>
                                                                        <p class="mb-0 hp-badge-text fw-normal dd-none">
                                                                            Manage your bookmarked posts</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="col hp-flex-none w-auto">
                                                                
                                                            </div>
                                                        </div>

                                                        <div class="divider mt-32  "></div>

                                                    </router-link>


                                                </div>


                                                <div class="mb-24" style="margin-top: 550px;">


                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <SuggestionsBody/>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>


    </main>




    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>


    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<style scoped>

    .shx{
        width: 1000px;   
    }

    .shm{
        max-width: 100%;
        max-height: 500px;
        object-fit: cover;
    }

    @media only screen and (max-width: 666px){

        .shx{
            width: 350px;
            
        }

        .shm{
            max-width: 100%;
            max-height: 700px;
            object-fit: cover;
        }

    }

</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc } from "firebase/firestore"; 
    import {getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential} from "firebase/auth"
    import { db } from '@/firebase';
    

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody
        },

        data(){

            return{
                loadingText:"",
                errorText: "",
                successText: "",
                
            }

        },

        mounted(){

            document.body.style.overflowY = 'scroll';
            document.body.style.padding = '0px';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Collections';

            document.getElementById("collectionN").classList.add("active");
            document.getElementById("collectionN2").classList.add("active");

            
            
            
        },
        
    }

</script>